<template>
  <div class="single-income">
    <div class="total">

    </div>
    <div v-if="!list" class="text-center">
      <Loading></Loading>
    </div>
    <div v-if="list" class="list">
      <el-row type="flex" class="header">
        <el-col :lg="6" :xs="8" class="">
          添加时间
        </el-col>
        <el-col :lg="18" :xs="14" class="">
          商品
        </el-col>
        <!--<el-col :lg="4" :xs="14" class="" v-if="type==2">-->
          <!--添加用户量-->
        <!--</el-col>-->
      </el-row>

      <el-row type="flex" v-for="(item,index) in list" :key="index">
        <el-col :lg="6" :xs="8" class="">
          <span style="display: none;">{{item.tag}}</span>
          <p>{{item.create_time | dateFilter}}</p>
          <span>{{item.create_time | moment('HH:mm:ss')}}</span>
          <p class="business-name">
            <a :href="item.business_website" target="_blank" style="display: flex;align-items: center">
              <img :src="`https://pic.joyorders.com/country/${item.country.toLowerCase()}.png`" alt="country"
                   class="flag">
              {{item.business_name}}
            </a>
          </p>
          <p class="business-name" v-if="type==1" style="position: relative" @click="handleSearch(item.username)">
            <a target="_blank" class="line-end">
              {{item.username}}
            </a>
          </p>
          <span class="jo-count" v-if="type==2" :style="{
          'border-radius': item.total<99?'50%':'35%',
          'padding-right': item.total<99?'0':'4px',
          'padding-left': item.total<99?'0':'4px' }" style="padding-right: 4px;padding-left: 4px">
             {{item.total}}
          </span>
        </el-col>
        <el-col :lg="18" :xs="14">
          <div class="order-detail">
            <el-col class="line-list clearfix"  :lg="24" :xs="24" :md="18" :sm="24">
              <div class="order-line clearfix">
                <div class="img-container">
                  <div>
                    <a
                      class="img-wrapper"
                      :href='item.website.substr(0,7).toLowerCase() == "https://" || item.website.substr(0,8).toLowerCase() == "https://" ? item.website : "https://"+ item.website'
                      target="_blank">
                      <template v-if="item.enable_alternate_images==1">
                        <img v-if="item.picture" :src="item.picture" mode="aspectFit"/>
                        <div class="plh_img" style="height:100%;" v-else>
                          <div v-if="item[item.unique_param]" class="plh_img_walk"
                               :style="{backgroundImage:'url('+item[item.unique_param].color_image_url+')'}"></div>
                        </div>
                      </template>
                      <template v-else>
                        <img v-if="item.picture" :src="item.picture"/>
                        <img v-else src="https://pic.joyorders.com/blank.png"/>
                      </template>
                      <span class="goodsNum" v-if="item.number>1">{{item.number}}</span>
                      <span v-if="item.recommendation_index!=0" class="star-container"
                            :style="handleStyle(item.recommendation_index)">
                        <span class="number">{{item.recommendation_index}}</span>
                      </span>
                    </a>
                  </div>
                </div>
                <div class="order-des">
                  <p class="name" style="position: relative;display: flex;align-items: center">
                    <a
                      :href='item.website.substr(0,7).toLowerCase() == "http://" || item.website.substr(0,8).toLowerCase() == "https://"  ? item.website : "http://"+ item.website'
                      target="_blank">{{showProductName(item)}}</a>
                    <el-popover
                      placement="top-start"
                      class="jo-popover"
                      style="margin-left: 0.5rem"
                      :ref="`popover-${item.product_id}`"
                      trigger="click">
                      <div>
                        <div class="packStatus">
                          <el-dropdown @command="handleRecommendIndex"
                                       :popperAppendToBody="false"
                          >
                                <span class="el-dropdown-link to_dos"
                                      style="width: 8rem;display: flex;justify-content: space-around;align-items: center">
                                  <span>推荐指数</span><span style="margin-left: .5rem">{{item.recommendation_index}}</span><i
                                  class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                            <el-dropdown-menu slot="dropdown" class="dropdownStatus" style="width: 4rem">
                              <el-dropdown-item :command="`0_${item.product_id}`">0</el-dropdown-item>
                              <el-dropdown-item v-for="(i) in 8" :key="i" :command="`${i}_${item.product_id}`">{{i}}
                              </el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>
                      </div>
                      <span slot="reference" class="moreIcon"><i class="el-icon-more"></i></span>
                    </el-popover>
                  </p>
                  <!-- <p class="notMobile"><span>规格：</span>{{item.spec}}</p> -->
                  <div class="notMobile spec">
                    <span v-html="formatSpec(item.spec,item)"></span>
                  </div>
                  <div style="height:24px;" v-show="!formatSpec(item.spec,item)">
                  </div>
                  <div class="notMobile spec" v-show="item.product_sku" style="position:relative;">
                    <span>货号：</span>
                    <span>{{item.product_sku}}</span>
                  </div>
                  <div v-if="item.discounted_price<0" class="notMobile"
                       style="display: flex;align-items: center;">
                    <p class="order-price">--</p>
                  </div>
                  <div v-else-if="!priceValidate(item)" class="notMobile"
                       style="display: flex;align-items: center;">
                    <a class="order-price">{{(item.discounted_price)|currency(item.currency_symbol)}}</a>
                    <del class="order-price"> {{(item.price)|currency(item.currency_symbol)}}</del>
                  </div>
                  <div v-else class="notMobile"
                       style="display: flex;align-items: center;">
                    <p class="order-price"> {{(item.price)|currency(item.currency_symbol)}}</p>
                  </div>
                </div>
              </div>
            </el-col>
          </div>
        </el-col>
        <!--<el-col :lg="4" :xs="14" class="" v-if="type==2">-->
          <!--<p>{{item.total}}</p>-->
        <!--</el-col>-->
      </el-row>
    </div>

  </div>
</template>


<script>
  import {formatSpec, handleStyle, showProductName} from "../../../services/tools";
  import api from "../../../services/api";

  let _ = require('lodash')
  let $ = require('jQuery')

  export default {
    name: 'Collapse',
    props: ['list', 'type'],
    components: {},
    computed: {},
    data() {
      return {
        visible: false,
        selectedRow: {},
        dialogFormVisible: false,
        showProductName: showProductName,
        formatSpec: formatSpec,
      }
    },
    created() {
      let that = this;
      window.onresize = () => {
        that.screenWidthWee = document.body.clientWidth
      }
    },
    mounted() {

    },
    methods: {
      priceValidate(item) {
        if (item.discounted_price) {
          return item.discounted_price - item.price == 0
        }
        return false;
      },
      async handleRecommendIndex(val) {
        let param = {};
        param.good_id = val.split("_")[1];
        param.recommendation_index = val.split("_")[0];
        let res = await api.updateRecommendationIndex(this, param);
        if (res.body.status == 'ok') {
          let find = this.list.find(item => item.product_id == param.good_id);
          find.recommendation_index = param.recommendation_index;
          let pop1 = `popover-${param.good_id}`;
          this.$refs[pop1][0].doClose();
        }
      },
      handleStyle(val) {
        return handleStyle(val)
      },
      handleSearch(username) {
        this.$emit('search', {username: username})
      }
    },
    beforeDestroy: function () {
      clearInterval(this.timer)
      $('body').removeClass('mobile-body-hidden')
    },

  }

</script>
<style scoped lang="scss">
  .star-container {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
  }

  .moreIcon {
    cursor: pointer;
    text-align: center;
    border: 1px solid transparent;
    border-radius: 50%;
    transform: rotate(90deg);
    height: 15px;
    width: 15px;
    line-height: 15px !important;
    display: inline-block;

    &:hover {
      border-color: rgb(215, 240, 253);
      background: rgb(215, 240, 253);
    }
  }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  p {
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
    padding-top: 5px;

    a {
      cursor: pointer;
      color: #333333;

      .el-icon-caret-bottom {
        padding-left: 3px;
        color: #333333;
      }
    }
  }

  .constantGroupOrderLine {
    width: 130px;
    height: 120px;
    display: flex;
    align-items: center;
  }

  .id_card_div {
    min-width: 257px;
    max-width: 310px;
  }

  .id_card_div p {
    color: #666666;
    line-height: 22px;
    white-space: normal;
  }

  .bold {
    color: #333;
    font-size: 16px;
    margin-bottom: 3px;
  }

  .id_card_img {
    width: 45%;
    position: relative;
    cursor: pointer;
  }

  .id_card_img img {
    width: 100%;
    object-fit: contain;
  }

  .id_card_img i {
    display: none;
  }

  .id_card_img:hover i {
    display: block;
    font-size: 30px;
    position: absolute;
    top: 25%;
    left: 40%;
  }

  .suspension {
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100px;
    border-top: 1px #ccc solid;
    background-color: #fff;
    z-index: 4444;

    .flexBtn {
      flex-grow: 1;
      text-align: center;
      padding: 15px 0;

      .operationIco {
        font-size: 28px;
        color: #0F66CF;

        &.moneyIco {
          display: inline-block;
          height: 26px;
          width: 25px;
          background-image: url('../../../assets/images/money@2x.png');
          background-repeat: no-repeat;
          background-size: contain;

        }
      }

      .operationBtn {
        font-size: 12px;
        color: #0F66CF;
        margin-top: 15px;
      }
    }
  }

  .isMobile {
    display: none;
  }

  .copy {
    width: 14px;
    vertical-align: middle;
  }

  .copyTxt {
    float: right;
    cursor: pointer;

    &.copyTxtSuccess, &.copyIdCardSuccess {
      background-color: #f4f4f5;
      color: #909399;
      padding-left: 10px;
    }
  }

  .order-header {
    background: rgba(243, 243, 249, 1);
    padding: 30px;
    margin-top: 33px;
    border: 1px solid #D7D7D7;
    border-bottom: none;
    overflow: hidden;

    .detail-button {
      float: right;
      color: #0F66CF;
      cursor: pointer;
    }

    .detail-text {
      color: #333333;
      font-size: 14px;
      float: left;
    }

    .detail-time {
      color: #999999;
      font-size: 12px;
      float: left;
      clear: both;
    }

    li {
      float: left;
      margin-right: 50px;
    }

    .business-name {
      min-width: 100px;
      word-break: break-all;
      display: flex;
      align-items: center;
    }

    span {
      color: rgba(136, 136, 136, 1);
      line-height: 20px;
    }

    .order_no {
      cursor: pointer;
      color: inherit;
    }

    .search_tag {
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }

    p {
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      padding-top: 5px;

      a {
        cursor: pointer;
        color: #333333;

        .el-icon-caret-bottom {
          padding-left: 3px;
          color: #333333;
        }
      }
    }
  }

  .order-detail {

    .line-list {

      padding-right: 30px;

      .img-container {
        float: left;
        width: 120px;
        height: 120px;


        a {
          position: relative;
          overflow: visible;
          display: block;
          width: 120px;
          height: 120px;

          .goodsNum {
            position: absolute;
            top: -10px;
            right: 0;
            display: inline-block;
            height: 20px;
            width: 20px;
            border: 1px solid #D7D7D7;
            border-radius: 50%;
            text-align: center;
            font-size: 10px;
            line-height: 18px;
            color: white;
            background: black;
          }
        }

        img {
          // width: 100%;
          // position: absolute;
          // left: 0;
          // top: 50%;
          // -webkit-transform: translateY(-50%);
          // transform: translateY(-50%);
          height: 120px;
          width: 120px;
          object-fit: contain;
        }
      }

      .order-des {
        float: left;
        margin-top: -5px;
        margin-left: 20px;

        .compareExpress_div {
          position: absolute;
          left: 180px;
          min-width: 250px;
          min-height: 20px;
          top: -25px;
        }

        .buyAgain {
          height: 32px;
          width: 80px;
          text-align: center;
          line-height: 32px;
          border: 1px solid #DEE1EB;
          border-radius: 3px;
          background: #F3F3F9;
          font-size: 12px;
          color: #686B73;
          margin-left: 5px;
          cursor: pointer;
          float: right;
        }

        .buyAgain.compareExpress {
          background: #0f66cf;
          border: 1px solid #0f66cf;
          color: white;
          border-radius: 3px;
          width: max-content;
          padding: 0 20px;
          margin-bottom: 5px;
          display: flex;
        }

        .buyAgain.compareExpress a {
          color: white;
        }
      }

      .order-state {
        float: right;
        text-align: right;

        p {
          color: #888888;
          margin-bottom: 20px;
        }
      }
    }

    .order-line {
      margin-bottom: 30px;

      &:last-child {
        margin-bottom: 0;
      }

      .name {
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        line-height: 20px;
        /*&:hover {*/
        /*.moreIcon {*/
        /*display: inline-block;*/
        /*}*/
        /*}*/
      }

      .order-des {
        position: relative;
        min-height: 120px;

        .timeIco {
          text-align: center;
          margin-bottom: 10px;
          margin-top: 20px;
        }

        .descripe {
          color: #888;
          font-size: 18px;

          .voucher {
            cursor: pointer;
            text-decoration: underline;
          }
        }

        .order-price {
          font-size: 18px;
          line-height: 32px;
          color: black;
          margin: 0;
        }

        a.order-price {
          color: #FF4650;
          font-size: 18px;
        }

        del.order-price {
          color: #B0B4BF;
          font-size: 16px;
        }
      }

      p {
        font-size: 12px;
        color: #333333;
        line-height: 17px;
        margin-bottom: 6px;

        span {
          color: #999;
          font-size: 12px;
        }

        a {
          color: #333333;
        }
      }

      .price {
        font-size: 18px;
        color: rgba(51, 51, 51, 1);
        line-height: 25px;
        position: absolute;
        min-width: 200px;
        bottom: 0;
        margin: 0;
      }
    }

    .operation-container {
      padding-left: 50px;
    }
  }

  .popover-price {
    li {
      clear: both;
      text-align: right;
      color: #333333;
      line-height: 24px;

      span {
        float: left;
        color: #999999;
      }

      del {
        color: #B0B4BF;
      }
    }

    .line {
      float: left;
      width: 100%;
      height: 1px;
      border: 1px dashed #ccc;
    }
  }

  .modify-price {
    padding: 10px 5px;

    div {
      clear: both;
      text-align: right;
      color: #333333;
      line-height: 24px;

      span {
        float: left;
        color: #999999;
      }
    }

  }

  .modify {
    padding: 0 5px;

    div {
      clear: both;
      text-align: right;
      color: #333333;
      line-height: 24px;

      span {
        float: left;
        color: #999999;
      }
    }

  }

  .offlineLabel {
    position: absolute;
    left: -4px;
    font-size: 12px;
    height: 22px;
    width: 60px;
    text-align: center;
    padding: 5px 5px;
    border-radius: 20px;
    color: #fff;
    background: rgb(254, 160, 0);
  }

  .unpaidline {
    position: absolute;
    font-size: 12px;
    height: 22px;
    width: 500px;
  }

  .unpaidlineLabel {
    display: inline-block;
    width: auto;
    line-height: 22px;
    padding: 0 8px;
    text-align: center;
    border-radius: 4px;
    color: #fff;
    background: black;

    &.miniprogram {
      background: #0f66cf;
    }

    &.alreadypaid {
      background: white;
      color: black;
    }

    &.waitingcacu {
      background: black;
      color: white;
    }

    &.exception {
      background-color: #fff1f1;
      color: #ff4650;
    }
  }

  .redirct {
    font-size: 24px;
    line-height: 33px;
    margin-top: 54px;
    padding-bottom: 70px;

    .completion {
      background-image: url('../../../assets/images/Group@2x.png');
      background-position: 0 0;
      background-size: contain;
    }

    a {
      font-size: 16px;
    }

    p {
      line-height: 24px;
      color: #888
    }
  }

  .buyTitle {
    text-align: center;
    color: #333333;
    font-size: 18px;
    padding-bottom: 40px;
  }

  .addCart {
    display: inline-block;
    height: 25px;
    width: 25px;
    background: url('../../../ico/cart_icon.svg') no-repeat;
    background-size: contain;
    vertical-align: middle;
    position: relative;
    margin-right: 10px;
  }

  .website-name {
    font-size: 18px;
    color: rgba(51, 51, 51, 1);
    line-height: 25px;
    text-align: left;
    word-break: break-all;
  }

  .website-url {
    font-size: 13px;
    color: rgba(102, 102, 102, 1);
    line-height: 18px;
    text-align: left;
    margin-bottom: 10px;
    word-break: break-all;
  }

  .buyContent {
    border-top: 1px solid #CDCDCD;
    // max-height: 286px;
    // overflow-y: auto;
    // overflow-x: hidden;

    .content-container {
      padding-right: 60px;
      width: 100%;
      position: relative;

      & > div {
        border-bottom: 1px solid #CDCDCD;
        padding: 20px 0;
      }

      .inline-block {
        margin-left: 0;
        margin-top: 10px;
        // position: absolute;
        // bottom: 20px;
      }
    }

    .img-container {
      float: left;
      width: 120px;
      height: 120px;
      overflow: hidden;

      img {
        width: 100%;
        position: absolute;
        left: 0;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
      }
    }

    li {
      &:last-child {
        .content-container {
          & > div {
            border-bottom: none;
          }
        }
      }
    }

    .line-des {
      margin-left: 130px;
      position: relative;

      p {
        line-height: 24px;
        word-break: break-all;

        span {
          color: #888888;
        }

        a {
          color: #333333;
        }
      }

      .inline-block {
        margin-left: 0;
        // position: absolute;
        // bottom: -39px;
      }

      .order-price {
        font-size: 18px;
        line-height: 24px;
        color: black;
        margin: 0;
      }

      a.order-price {
        color: #FF4650;
        font-size: 18px;
      }

      del.order-price {
        color: #B0B4BF;
        font-size: 16px;
      }
    }

  }

  .chat-component {
    position: absolute;
    z-index: 999;
    right: 30px;
  }

  .gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);

    filter: grayscale(100%);

    filter: gray;
  }

  .back {
    float: left;
    color: #C0C4CC;
    font-size: 26px;
    line-height: 30px;
    cursor: pointer;
  }

  @media screen and (max-width: 1024px) {
    .notMobile {
      display: none !important;
    }
    .isMobile {
      z-index: 2;
      display: block !important;
    }
    .order-header {

      li {
        margin-right: 23px !important;
      }
    }
    .order-foot {
      overflow: hidden;
      padding: 20px;
      border-left: 1px solid #D7D7D7;
      border-right: 1px solid #D7D7D7;
      border-bottom: 1px solid #D7D7D7;

      .foot-price {
        float: right;

        a {
          color: #333333;
        }
      }
    }
    .order-detail {
      padding: 20px 15px !important;

      .line-list {
        border-right: none;
        position: relative;
        padding-right: 0 !important;

        .img-container {
          width: 80px;
          height: 80px;

          a {
            width: 80px;
            height: 80px;

            img {
              width: 80px;
              height: 80px;
            }
          }
        }

        .order-state {
          float: none;
          position: absolute;
          right: 0;
          top: 50%;

          div {
            display: inline-block;
          }

          .tabBar {
            .el-icon-arrow-right {
              cursor: pointer;
              vertical-align: middle;
            }
          }
        }
      }

      .order-line {
        .order-des {
          height: auto;
          margin-left: 10px !important;
        }
      }
    }
  }

  @media screen and (max-width: 769px) {
    .order-header {
      padding: 10px !important;
    }
    .order-detail {
      padding: 20px 15px !important;

      .line-list {
        border-right: none;
        position: relative;
        padding-right: 0 !important;

        .img-container {
          width: 80px;
          height: 80px;

          a {
            width: 80px;
            height: 80px;

            img {
              width: 80px;
              height: 80px;
            }
          }

          img {
            width: 80px;
            height: 80px;
          }
        }

        .order-state {
          float: none;
          position: absolute;
          right: 0;
          top: 50%;

          div {
            display: inline-block;
          }

          .tabBar {
            .el-icon-arrow-right {
              vertical-align: middle;
            }
          }
        }
      }

      .order-line {

        .order-des {
          height: auto;
          margin-left: 10px !important;

          .name {
            word-break: break-all;
            max-width: 170px;
          }
        }
      }
    }

    .detail-title {
      padding: 10px 0 10px;
      text-align: center;
      font-size: 18px;
      color: #333333;
      border-bottom: 1px solid #D7D7D7;
    }

    .detail-body {
      position: relative;
      padding: 15px;
      border-bottom: 1px solid #D7D7D7;

      h2 {
        font-size: 14px;
        color: #333333;
        padding: 10px 0;
      }

      p {
        margin-bottom: 10px;
        color: #888888;
      }

      .popover-price {
        padding: 0 0 10px !important;
      }

      .mobile-order-state {
        display: inline-block;
        position: absolute;
        right: 20px;
        top: 25px;
      }

      .buyContent {
        border-top: none !important;

        .img-container {
          width: 80px;
          height: 80px;
        }

        .line-des {
          margin-left: 98px !important;

          .order-price {
            font-size: 14px !important;

            &.a {
              font-size: 14px !important;
            }

            &.del {
              font-size: 14px !important;
            }
          }

          p {
            margin-bottom: 5px !important;
          }

        }

        .content-container {

          & > div {
            border-bottom: none !important;
          }
        }
      }
    }
  }

  .weeCtCoverBeforeDeal {
    position: relative;
    /*width: 380px;*/
    /*width: 310px;*/
    width: 430px;
    height: 135px;

    .coverMore {
      position: absolute;
      right: 0;
      top: 0;
      width: 50px;
      height: 120px;
      background-image: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, .25), rgba(255, 255, 255, .75), rgba(255, 255, 255, .90), white);
      z-index: 1;
    }

    .ctCover {
      height: 120px;
      /*width: 3700px;*/
      display: flex;
      /*flex-wrap: nowrap;*/
      .cover {
        /*display: inline-block;*/
        width: 120px;
        height: 120px;
        margin-right: 10px;
        background-size: contain !important;

        &:last-of-type {
          margin-right: 25px;
        }

        cursor: pointer;
      }

      /*.gm-scroll-view{*/
      /*    display: flex;*/
      /*}*/
    }
  }

  @media screen and (max-width: 1024px) {
    .weeCtCoverBeforeDeal {
      position: relative;
      /*width: 380px;*/
      width: 310px;
      /*width: 430px;*/
      height: 95px;

      .coverMore {
        position: absolute;
        right: 0;
        top: 0;
        width: 50px;
        height: 80px;
        background-image: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, .25), rgba(255, 255, 255, .75), rgba(255, 255, 255, .90), white);
        z-index: 1;
      }

      .ctCover {
        height: 80px;
        /*width: 3700px;*/
        display: flex;
        /*flex-wrap: nowrap;*/
        .cover {
          /*display: inline-block;*/
          width: 80px;
          height: 80px;
          margin-right: 10px;
          background-size: contain !important;

          &:last-of-type {
            margin-right: 25px;
          }

          cursor: pointer;
        }

        /*.gm-scroll-view{*/
        /*    display: flex;*/
        /*}*/
      }
    }
  }

  .spec {
    display: flex;
    word-break: break-all;
    color: #888888;
    line-height: 24px;

    span {
      display: block;
    }
  }

  .joyorderIcon {
    position: relative;
    top: 2px;
  }

  .joyorderIcon.taobao {
    font-size: 20px;
    top: 3px;
  }

  @font-face {
    font-family: "iconfont"; /* Project id 2668685 */
    /* Color fonts */
    src: url('../../../assets/iconfont/iconfont.woff2?t=1626081681400') format('woff2'),
    url('../../../assets/iconfont/iconfont.woff?t=1626081681400') format('woff'),
    url('../../../assets/iconfont/iconfont.ttf?t=1626081681400') format('truetype');
  }

  .iconfont {
    font-family: "iconfont" !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .el-icon-joyordercopy-document:before {
    content: "\e64a";
  }

  .el-icon-joyorderxiazai:before {
    content: "\e617";
  }

  .el-icon-joyordershenfenzhengrenzheng:before {
    content: "\e609";
  }

  .el-icon-joyorderkefu:before {
    content: "\e606";
  }

  .el-icon-joyorderweixin:before {
    content: "\e6ea";
  }

  .el-icon-joyorder26:before {
    content: "\e615";
  }

  .promo_code {
    border: 1px solid #D9D9D9;
    display: inline-block;
    padding: 0 10px;
    font-size: 13px;
  }

  .edit_modify_div {
    cursor: pointer;
  }

  .el-icon-edit-outline.edit_modify {
    margin-right: 10px;
  }

  .flag {
    width: 20px;
    height: 14px;
    object-fit: contain;
    margin-right: 5px;
  }

  .el-popover {
    .clearfix:nth-of-type(1) {
      margin-top: 0 !important;
    }
  }

  .exception-label {
    color: #ff4650;
    background-color: #fff1f1;
    cursor: pointer;

    &.tips {
      color: #0f66cf;
      background-color: transparent;
    }

    &.close {
      color: #888888;
      background-color: #f3f3f9;
    }
  }

  .mail-top {
    position: absolute;
    bottom: 30px;
    right: 50px;
    display: flex;
    align-items: center;
  }

  .mail-body {
    .mail-link {
      height: 30px;
      border-left: 1px dashed #D7D7D7;
      border-right: 1px dashed #D7D7D7;
    }

    .mail-content {
      border: 1px solid #D7D7D7;
      border-top: none;
    }

    .table-row-title {
      display: flex;
    }

    .table-row-content {
      padding: 25px 50px 0 30px;
    }
  }
</style>
<style scoped lang="scss">
  .single-income {
    padding: 0 35px 60px;

    .total {
      .block {
        width: 108px;
        margin-top: 15px;
        margin-bottom: 50px;
      }

      span {
        font-size: 14px;
        color: #333;
        line-height: 26px;
      }

      p {
        font-size: 33px;
        color: #666;
      }
    }

    .header {
      color: #333;
    }

    .list {
      .el-row {
        padding: 0 18px 18px;
        border-bottom: 1px solid #EBEBEB;
        margin-bottom: 18px;
      }

      p {
        font-size: 16px;
        padding-bottom: 5px;
      }

      span {
        color: #666;
      }

      .payInfo {
        font-size: 16px;
        line-height: 26px;
      }
    }

  }

  @media screen and (max-width: 1024px) {
    .single-income {
      padding: 0 0 60px;

      .list {

        .el-row {
          padding: 0 0 18px;
        }

        p {
          line-height: 20px;

        }
      }

      .total {
        .el-row {
          display: inline-block;
        }

        p {
          font-size: 18px;
        }

        .block {
          margin-bottom: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/cart/CartBody.vue